import { render, staticRenderFns } from "./DependentView.vue?vue&type=template&id=d1ae54d8&"
import script from "./DependentView.vue?vue&type=script&lang=js&"
export * from "./DependentView.vue?vue&type=script&lang=js&"
import style0 from "./DependentView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports